import type { ChatTurn } from "./types";

const KEY = (taskId: string) => `taskEditorChat:v2:${taskId}`;

export interface PersistedChat {
  threadId: string | null;
  turns: ChatTurn[];
}

const EMPTY: PersistedChat = { threadId: null, turns: [] };

export function loadChat(taskId: string): PersistedChat {
  if (typeof window === "undefined") return EMPTY;
  try {
    const raw = window.localStorage.getItem(KEY(taskId));
    if (!raw) return EMPTY;
    const parsed = JSON.parse(raw) as PersistedChat;
    if (!parsed || !Array.isArray(parsed.turns)) return EMPTY;
    return {
      threadId: typeof parsed.threadId === "string" ? parsed.threadId : null,
      turns: parsed.turns,
    };
  } catch {
    return EMPTY;
  }
}

export function saveChat(taskId: string, state: PersistedChat): void {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(KEY(taskId), JSON.stringify(state));
  } catch {
    // quota / serialization error — ignore
  }
}

export function clearChat(taskId: string): void {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.removeItem(KEY(taskId));
  } catch {
    // ignore
  }
}
